import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { logPageView } from '../../models/Analytics';
import { MainContainer } from '../MainContainer';
import './styles.less';

interface IProps extends RouteComponentProps<any> {
	className?: string;
}

interface IState {
	showRequestInvitePopup?: boolean;
}

export class Terms extends React.Component<IProps, IState> {
	public state: IState = {
		showRequestInvitePopup: false,
	};

	public componentDidMount() {
		window.scrollTo(0, 0);
		document.title = 'Levitate - Terms of Service';
		logPageView('Terms');
	}

	public render() {
		return (
			<MainContainer>
				<div className='terms-outerContainer'>
					<h1>Levitate Terms of Service</h1>

					<p>
						<em>The Terms of Service were last updated on March 19, 2020</em>
					</p>

					<h2>Introduction</h2>

					<p>
						Welcome to Levitate. This website is owned and operated by Real Magic, Inc. By visiting our website and accessing
						the information, resources, services, products, and tools we provide, you understand and agree to accept and adhere
						to the following terms and conditions as stated in this policy (hereafter referred to as 'User Agreement'), along
						with the terms and conditions as stated in our Privacy Policy (please refer to the Privacy Policy section below for
						more information).
					</p>

					<p>This agreement is in effect as of Mar 07, 2018.</p>

					<p>
						We reserve the right to change this User Agreement from time to time.
						When we make changes to the User Agreement, we will make reasonable efforts to notify all users
						by sending an e-mail communication to our active user list based on our database records.
						However, because we cannot guarantee that our e-mail communication will be delivered or viewed,
						you acknowledge and agree that it is your responsibility to review this User Agreement periodically to familiarize yourself with any modifications.
						Your continued use of this site after such modifications will constitute acknowledgment and agreement of the modified
						terms and conditions.
					</p>

					<h2>Responsible Use and Conduct</h2>

					<p>
						By visiting our website and accessing the information, resources, services, products, and tools we provide
						for you, either directly or indirectly (hereafter referred to as 'Resources'), you agree to use these Resources
						only for the purposes intended as permitted by (a) the terms of this User Agreement, and (b) applicable laws,
						regulations and generally accepted online practices or guidelines.
					</p>

					<p>Wherein, you understand that:</p>

					<p>
						a. In order to access our Resources, you may be required to provide certain information about yourself
						(such as identification, contact details, etc.) as part of the registration process, or as part of your
						ability to use the Resources. You agree that any information you provide will always be accurate, correct, and up to date
						to the best of your knowledge.
					</p>

					<p>
						b. You are responsible for maintaining the confidentiality of any login information associated with any account you use
						to access our Resources. Accordingly, you are responsible for all activities that occur under your account/s
						except to the extent the activities relate to our acts.
					</p>

					<p>
						c. Accessing (or attempting to access) any of our Resources by any means other than through the means we provide,
						is strictly prohibited. You specifically agree not to access (or attempt to access) any of our Resources through
						any automated, unethical or unconventional means.
					</p>

					<p>
						d. Engaging in any activity that disrupts or interferes with our Resources, including the servers and/or networks
						to which our Resources are located or connected, is strictly prohibited.
					</p>

					<p>
						e. Attempting to copy, duplicate, reproduce, sell, trade, or resell our Resources is strictly prohibited.
					</p>

					<p>
						f. You are solely responsible any consequences, losses, or damages that we may directly or indirectly incur or suffer
						due to any unauthorized activities conducted by you, as explained above, and may incur criminal or civil liability.
					</p>

					<p>
						g. We may provide various open communication tools on our website, such as blog comments, blog posts, public chat,
						forums, message boards, newsgroups, product ratings and reviews, various social media services, etc. You understand
						that generally we do not pre-screen or monitor the content posted by users of these various communication tools,
						which means that if you choose to use these tools to submit any type of content to our website, then it is your
						personal responsibility to use these tools in a responsible and ethical manner. By posting information or otherwise
						using any open communication tools as mentioned, you agree that you will not upload, post, share, or otherwise
						distribute any content that:
					</p>

					<p>
						i. Is illegal, threatening, defamatory, abusive, harassing, degrading, intimidating, fraudulent, deceptive, invasive, racist, or contains any type of suggestive, inappropriate, or explicit language;<br />
						ii. Infringes on any trademark, patent, trade secret, copyright, or other proprietary right of any party;<br />
						iii. Contains any type of unauthorized or unsolicited advertising;<br />
						iv. Impersonates any person or entity, including any Real Magic employees or representatives.<br />
					</p>

					<p>
						We have the right at our reasonable discretion to remove any content that, we feel in our judgment does not comply with this
						User Agreement, along with any content that we feel is otherwise offensive, harmful, objectionable, inaccurate, or
						violates any 3rd party copyrights or trademarks. We are not responsible for any delay or failure in removing such
						content. If you post content that we choose to remove, you hereby consent to such removal, and consent to waive any
						claim against us.
					</p>

					<p>
						h. We do not assume any liability for any content posted by you or any other 3rd party users of our website.
						However, any content posted by you using any open communication tools on our website, provided that it doesn't
						violate or infringe on any 3rd party copyrights or trademarks, becomes the property of Real Magic, Inc, and as such,
						gives us a perpetual, irrevocable, worldwide, royalty-free, exclusive license to reproduce, modify, adapt, translate,
						publish, publicly display and/or distribute as we see fit. This only refers and applies to content posted via open
						communication tools as described, and does not refer to information that is provided as part of the registration
						process, necessary in order to use our Resources.
					</p>
					<p>
						Note that the above statemen refers to data created on open communication tools on our web site such as comments on
						the Levitate blog or posts to the support forum. <strong>All information provided as part of our registration process and all content that you create after logging into Levitate,
						including (but not limited to) notes, contacts, companies, and action items in the Levitate application is covered by our Privacy Policy.</strong>
					</p>

					<p>
						i. You agree to indemnify and hold harmless Real Magic, Inc and its parent company and affiliates, and their directors,
						officers, managers, employees, donors, agents, and licensors, from and against all losses, expenses, damages and costs,
						including reasonable attorneys' fees, resulting from any violation of this User Agreement or the failure to fulfill any
						obligations relating to your account incurred by you or any other person using your account. We reserve the right to
						take over the exclusive defense of any claim for which we are entitled to indemnification under this User Agreement.
						In such event, you shall provide us with such cooperation as is reasonably requested by us.
					</p>

					<h2>Data Ownership</h2>

					<p>
						As part of our service to customers, Levitate stores names, contact information, key facts, and notes
						in our system. <strong>While we store this data on behalf of our customers, our customers maintain ownership of
						data that they import or manually enter in the Levitate application.</strong>
					</p>

					<h2>Privacy</h2>

					Your privacy is very important to us, which is why we've created a separate Privacy Policy in order to explain
					in detail how we collect, manage, process, secure, and store your private information. Our privacy policy is
					included under the scope of this User Agreement.
					To read our privacy policy in its entirety, <a href='https://www.levitate.ai/#/privacy' target='_blank'>click here</a>.

					<h2>Limitation of Warranties</h2>

					<p>
						By using our website, you understand and agree that all Resources we provide are "as is" and "as available".
						This means that we do not represent or warrant to you that:
					</p>

					<p>
						i) the use of our Resources will meet your needs or requirements.<br />
						ii) the use of our Resources will be uninterrupted, timely, secure or free from errors.<br />
						iii) the information obtained by using our Resources will be accurate or reliable, and<br />
						iv) any defects in the operation or functionality of any Resources we provide	will be repaired or corrected.<br />
					</p>

					<p>Furthermore, you understand and agree that:</p>

					<p>
						v) any content downloaded or otherwise obtained through the use of our Resources is done at your own discretion and risk, and
						that you are solely responsible for any damage to your computer or other devices for any loss of data that may result from the
						download of such content.
					</p>

					<p>
						vi) no information or advice, whether expressed, implied, oral or written, obtained by you from Real Magic, Inc or through
						any Resources we provide shall create any warranty, guarantee, or conditions of any kind, except for those expressly outlined
						in this User Agreement.
					</p>

					<h2>Limitation of Liability</h2>

					<p>
						In conjunction with the Limitation of Warranties as explained above, you expressly understand and agree that any
						claim against us shall be limited to the amount you paid, if any, for use of products and/or services. Real Magic, Inc
						will not be liable for any direct, indirect, incidental, consequential or exemplary loss or damages which may be incurred
						by you as a result of using our Resources, or as a result of any changes, data loss or corruption, cancellation, loss
						of access, or downtime to the full extent that applicable limitation of liability laws apply.
					</p>

					<h2>Copyrights/Trademarks</h2>

					<p>
						All content and materials available on https://www.levitate.ai, including but not limited to text, graphics, website name,
						code, images and logos are the intellectual property of Real Magic, Inc, and are protected by applicable copyright and
						trademark law. Any inappropriate use, including but not limited to the reproduction, distribution, display or transmission
						of any content on this site without our consent is strictly prohibited, unless specifically authorized by Real Magic, Inc.
					</p>

					<h2>Use of Integrations with Third-Parties</h2>

					<p>
						By enabling and either directly or indirectly utilizing the integrations between Levitate and other independent software vendors,
						you agree to use these Resources only for the purposes intended as permitted by (a) the terms of this User Agreement,
						(b) the Terms and Conditions of our third-party partner, and (c) applicable laws, regulations and generally accepted online practices or guidelines.
					</p>

					<h2>Termination of Use</h2>

					<p>
						You agree that we may, at our sole discretion, suspend or terminate your access to all or part of our website and
						Resources with or without notice and for any reason, including, without limitation, breach of this User Agreement.
						Any suspected illegal, fraudulent or abusive activity may be grounds for terminating your relationship and may be
						referred to appropriate law enforcement authorities. Upon suspension or termination, your right to use the Resources
						we provide will immediately cease, and we reserve the right to remove or delete any information that you may have on
						file with us, including any account or login information.
					</p>

					<h2>Governing Law</h2>

					<p>
						This website is controlled by Real Magic, Inc from our offices located in the state of NC, USA.
						It can be accessed by most countries around the world. As each country has laws that may differ from those of NC,
						by accessing our website, you agree that the statutes and laws of NC, without regard to the conflict of laws and
						the United Nations Convention on the International Sales of Goods, will apply to all matters relating to the use
						of this website and the purchase of any products or services through this site.
					</p>

					<p>
						Furthermore, any action to enforce this User Agreement shall be brought in the federal or state courts located in USA, NC.
						You hereby agree to personal jurisdiction by such courts, and waive any jurisdictional, venue, or inconvenient forum
						objections to such courts.
					</p>

					<h2>Guarantee</h2>

					<p>
						UNLESS OTHERWISE EXPRESSED, Real Magic, LLC EXPRESSLY DISCLAIMS ALL WARRANTIES AND CONDITIONS OF ANY KIND, WHETHER
						EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO THE IMPLIED WARRANTIES AND CONDITIONS OF MERCHANTABILITY, FITNESS
						FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT.
					</p>

					<h2>Contact Information</h2>

					<p>If you have any questions or comments about these our Terms of Service as outlined above, you can contact us at:</p>

					<p>
						Real Magic, Inc.<br />
						2409 Crabtree Blvd<br />
						Suite 107<br />
						Raleigh, NC 27604<br />
						USA<br />
						<a className='footerLink' href='tel:18882537050'>1-888-253-7050</a><br />
						<a className='footerLink' href='mailto:support@levitateapp.com'>support@levitateapp.com</a>
					</p>

				</div>
			</MainContainer>
		);
	}
}
